// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../admin/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Bulma Utilities */\n@media screen and (min-width: 769px) {\na[href*=\"tel:\"][data-v-0b03b0b0] {\n    cursor: default;\n    pointer-events: none;\n    color: hsl(0deg, 0%, 29%);\n}\n}\n.field .help[data-v-0b03b0b0] {\n  display: none;\n  font-size: 0.875rem;\n}\n.field--error .help[data-v-0b03b0b0] {\n  display: inline-block;\n}\n.field--error .select + .help[data-v-0b03b0b0] {\n  display: block;\n}", ""]);
// Exports
module.exports = exports;
